import React, { useEffect, useState } from 'react';
import ProjectCard from '../Projects/ProjectCard/ProjectCard';
import './AllProject.css';
import spinner from '../../images/spinner.gif';

const AllProject = () => {
        const [projects, setProjects] = useState([]);
        // Load All Projects:
        useEffect(() => {
                fetch('./projects.json')
                        .then(res => res.json())
                        .then(data => setProjects(data))
        }, []);

        // Spinner:
        if (!projects.length) {
                return <div className="spinner">
                        <div className="loading d-flex justify-content-center align-items-center pt-5">
                                <img className="img-fluid mt-5" src={spinner} alt="" />
                        </div>
                </div>
        }
        return (
                <div className="projects pt-5 pb-5 mt-5">
                        <div className="project-headline">
                                <marquee>
                                        <h1 className="text-center text-white fw-bold text-decoration-underline mb-5 mt-5 project-headline"
                                        >Some Of My<span className="brand-color"> Projects</span> </h1>
                                </marquee>
                        </div>
                        {
                                projects.map(project => <ProjectCard
                                        project={project}
                                        key={project.id}
                                >
                                </ProjectCard>)
                        }
                </div>
        );
};

export default AllProject;